import backendAPI from '../utils/backendAPI'

export const CLOVER_LOGIN_REQUEST = 'CLOVER_LOGIN_REQUEST'
export const CLOVER_LOGIN_SUCCESS = 'CLOVER_LOGIN_SUCCESS'
export const CLOVER_LOGIN_FAIL = 'CLOVER_LOGIN_FAIL'

export const cloverLogin = () => async (dispatch) => {
	try {
		dispatch({ type: CLOVER_LOGIN_REQUEST })

		const { data } = await backendAPI.get(`/api/clover/merchant/`)
		if (data) {
			localStorage.setItem('merchant_id', data.id)
			localStorage.setItem('access_token', data.access_token)
		}

		dispatch({
			type: CLOVER_LOGIN_SUCCESS,
			payload: data,
		})
	} catch (error) {
		dispatch({
			type: CLOVER_LOGIN_FAIL,
			payload:
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
		})
	}
}
